import { useEffect } from "react";
import { useUserContext } from "../../context/UserContext"
import { useNavigate } from "react-router-dom";
import type { ReactElement } from "react";
/**
* Props for the RequireAuth component.
*/ 
interface RequireAuthProps {
    children: ReactElement; // Children
}
/**
* Require auth. For wrapping components that need auth.
*
* @param props RequireAuth props
* @param {ReactElement} props.children - Child element
* @returns TSX.Element
*/
const RequireAuth = ({ children }: RequireAuthProps)=> {
    const {loggedIn} = useUserContext();
    const navigate = useNavigate();

    useEffect(() => {
        if(!loggedIn){
            navigate("/login")
        }
    }, [loggedIn, navigate]);
    
    return loggedIn ? children : null;
}

export default RequireAuth;